import Head from 'next/head'
import React from 'react'
import styled from 'styled-components'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'

const DESCRIPTION = `Book consultations with the world's top design experts`

const Iframe = styled('iframe')`
  width: 100%;
  height: inherit;
`

export const AustinRsvp = () => (
  <>
    <Head>
      <title>The Expert Austin RSVP</title>
      <meta name="description" content={DESCRIPTION} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta property="og:description" content={DESCRIPTION} />
    </Head>
    <Box
      width="100%"
      height={{ MOBILE: 'calc(100vh - 300px)', TABLET: 'calc(100vh - 150px)' }}
    >
      <Iframe
        className="airtable-embed"
        src="https://airtable.com/embed/app8lIOLo8lLJgV3b/pag57qG2YmNE0igy4/form"
        title="airtable form"
      />
    </Box>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

AustinRsvp.getLayout = (page) =>
  getPublicLayout(page, {
    isFullWidth: true,
  })
